"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
var _Modal = require("@ccw-pwa-ui/Modal");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Button = require("@ccw-pwa-ui/Button");
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
require("../styles/EditAccessoryComponent.css");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
const EditSystemComponent = _ref => {
  let {
    sequence,
    handleBack,
    headerText,
    inputLabel,
    dateChange,
    value,
    saveBtnTitle,
    saveBtnClick,
    saveBtnDisabled,
    backNavigationScreen,
    warningModal,
    isUpdating,
    warningModalData,
    saveErrorModalData,
    rightNavHeading,
    minInstallationDate,
    maxInstallationDate,
    modelNumber,
    handleCancel
  } = _ref;
  return isUpdating ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: backNavigationScreen,
    handleBack: handleBack,
    rightNavHeading: rightNavHeading,
    handleCancle: handleCancel,
    leftArrowImage: _index.default.leftArrow.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-bodyWrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-header"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "model-number-label"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: modelNumber
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-input-label-editSystem"
  }, inputLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-date-picker-EditSystem",
    "data-testid": "subSteper-date-picker"
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
    placeholderText: "Select Date",
    className: "edit-accessory-date",
    selected: value,
    onChange: date => dateChange(date, sequence),
    maxDate: maxInstallationDate,
    minDate: minInstallationDate
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.Union.default,
    alt: "",
    className: "email-icon2"
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-button",
    "data-testid": "edit-accessory-savebtn"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: saveBtnTitle,
    onClick: saveBtnClick,
    disabled: saveBtnDisabled
  })));
};
var _default = exports.default = EditSystemComponent;